module.exports = __webpack_public_path__ + "6cbd770f156625d8363915a82243cd6d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg14.jpeg
// module id = 22
// module chunks = 0